module.exports = __webpack_public_path__ + "static/media/bible-verse-main.40fbf160.png";